// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.admin-onboard {
    background-color: #ffffff;
    height: 100%;
    padding-inline: 50px;
    padding-top: 30px;
    margin-left: 14%;
    margin-top: 0;
}

.admin-onboard .onboard-nav {
    display: flex;
    align-items: center;
    border-bottom: 1px solid #EBEBEB;
    color: #A0A0A0;
}

.onboard-nav h1 {
    margin-right: auto;
    margin-left: 0;
    font-size: 18px;
    margin-bottom: 0;
}

.onboard-nav p {
    margin-right: auto;
    margin-bottom: 0;
}

.onboard-nav span {
    font-weight: 600;
    color: #000000;
    margin-left: 15px;
}

.onboard-nav ul {
    display: flex;
    gap: 30px;
    list-style: none;
    margin-bottom: 0;
}

.onboard-nav .nav-item {
    padding: 10px;
    color: #A0A0A0;
    font-weight: 100;
    cursor: pointer;
}

.onboard-nav .nav-item:hover {
    color: #2626E5;
}

.onboard-nav .active{
    color: #2626E5;
    font-weight: 500;
    border-bottom: 4px solid #002E5B;
}

.member .add-member-btn{
    background-color: #060D27;
    border: 1px solid #002E5B;
    color: #ffffff;
    padding: 8px;
    border-radius: 8px;
}

.member .fund {
    border: 0.5px solid #A0A0A0;
    border-radius: 8px;
    background-color: transparent;
    padding: 5px 18px;
    color: #A0A0A0;
}`, "",{"version":3,"sources":["webpack://./src/view/reporting-dashboard/onboarding/Onboarding.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,YAAY;IACZ,oBAAoB;IACpB,iBAAiB;IACjB,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,gCAAgC;IAChC,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,cAAc;IACd,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,cAAc;IACd,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,2BAA2B;IAC3B,kBAAkB;IAClB,6BAA6B;IAC7B,iBAAiB;IACjB,cAAc;AAClB","sourcesContent":[".admin-onboard {\n    background-color: #ffffff;\n    height: 100%;\n    padding-inline: 50px;\n    padding-top: 30px;\n    margin-left: 14%;\n    margin-top: 0;\n}\n\n.admin-onboard .onboard-nav {\n    display: flex;\n    align-items: center;\n    border-bottom: 1px solid #EBEBEB;\n    color: #A0A0A0;\n}\n\n.onboard-nav h1 {\n    margin-right: auto;\n    margin-left: 0;\n    font-size: 18px;\n    margin-bottom: 0;\n}\n\n.onboard-nav p {\n    margin-right: auto;\n    margin-bottom: 0;\n}\n\n.onboard-nav span {\n    font-weight: 600;\n    color: #000000;\n    margin-left: 15px;\n}\n\n.onboard-nav ul {\n    display: flex;\n    gap: 30px;\n    list-style: none;\n    margin-bottom: 0;\n}\n\n.onboard-nav .nav-item {\n    padding: 10px;\n    color: #A0A0A0;\n    font-weight: 100;\n    cursor: pointer;\n}\n\n.onboard-nav .nav-item:hover {\n    color: #2626E5;\n}\n\n.onboard-nav .active{\n    color: #2626E5;\n    font-weight: 500;\n    border-bottom: 4px solid #002E5B;\n}\n\n.member .add-member-btn{\n    background-color: #060D27;\n    border: 1px solid #002E5B;\n    color: #ffffff;\n    padding: 8px;\n    border-radius: 8px;\n}\n\n.member .fund {\n    border: 0.5px solid #A0A0A0;\n    border-radius: 8px;\n    background-color: transparent;\n    padding: 5px 18px;\n    color: #A0A0A0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
